<template>
  <div class="login_wrap">
    <headers @listen="showChild" />
    <div id="login_wrap_denglu">
      <div class="login_wrap_denglu_top">{{school_title}}账号密码登录</div>
      <router-link to="/msgcode-login" class="yanzhengma_enter">使用验证码登录></router-link>
    </div>
    <div id="login_wrap_form">
      <div class="login_wrap_form_wrap">
        <div class="login_wrap_form_wrap_tip">手机号码</div>
        <div class="login_wrap_form_number">
          <div class="login_wrap_form_number_left">
            <el-select v-model="value" placeholder="" class="login_wrap_form_number_left_se" filterable>
              <el-option v-for="item in cities" :key="item.label" :label="item.value" :value="item.value">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="login_wrap_form_number_right">
            <el-input v-model="input_content" placeholder="请输入手机号码" class="login_wrap_form_number_right_int" :class="{'colorerro':colorerro}"></el-input>
          </div>
        </div>
        <div class="number_erro" :class="{'colordisplay':errodisplay}">
          <div class="number_erro_content">{{numbererro}}</div>
        </div>
        <div class="login_wrap_form_passworld">
          <el-input placeholder="请输入密码" v-model="input_form_passworld" show-password :class="{'colorpasserro':colorpasserro}"></el-input>
        </div>
        <div class="password_erro" :class="{'colordisplays':errodisplays}">{{paddworderro}}</div>
        <div class="login_wrap_for_enter">
          <div class="login_wrap_for_enter_con" @click="form_data_enter()">登录</div>
        </div>
        <div class="login_wrap_form_forget_zhuce">
          <router-link to="/reset-password-by-phone" class="login_wrap_form_forget">忘记密码</router-link>
          <router-link to="/regist" class="login_wrap_form_zhuce">免费注册</router-link>
        </div>
        <social/>
      </div>
    </div>
    <footers/>
  </div>
</template>

<script>
import headers from "./header.vue";
import footers from "./footers.vue";
import social from "./social.vue";
import { JSEncrypt } from "jsencrypt";
import Net_Work from "../apis/network.js";
import _ from "lodash";
import axios from "axios";
import Qs from "qs";
import { change_token } from "../apis/token.js";
import Address from "../apis/address.js";

axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;
export default {
  name: "HelloWorld",
  components: { headers, social, footers },
  data() {
    return {
      numbererro: "手机号格式错误",
      paddworderro: "密码格式错误",
      isshool: false,
      msg: "",
      school_title: "",
      input_content: "",
      JSEncrypt: JSEncrypt,
      input_form_passworld: "",
      errodisplay: true,
      errodisplays: true,
      colorerro: false,
      colorpasserro: false,
      cities: Address.citiy,
      value: "+86"
    };
  },

  methods: {
    form_data_enter: _.throttle(function() {
      var number_quhao = Number(this.value);
      var _this = this;
      var number_true = false;
      var _password = false;
      if (number_quhao === 86) {
        var repx1 = /^1[012345789]\d{9}$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (repx1.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      } else {
        var rexpx2 = /^[0-9]\d*$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (rexpx2.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      }
      if (number_true) {
        if (this.input_form_passworld.length === 0) {
          this.errodisplays = false;
          this.colorpasserro = true;
          this.paddworderro = "密码不能为空";
        } else {
          this.errodisplays = true;
          this.colorpasserro = false;
          _password = true;
        }
      }
      if (number_true && _password) {
        axios
          .get("/s/api/get/public/key")
          .then(function(response) {
            if (response.data.code === 0) {
              _this.JSEncrypt.setPublicKey(response.data.data);
              var _pass_jiami = _this.input_form_passworld;
              _pass_jiami = _this.JSEncrypt.encrypt(_pass_jiami);
              axios
                .post(
                  "/s/api/login" /*最新代码位置*/,
                  Qs.stringify({
                    username: number_quhao + _this.input_content,
                    password: _pass_jiami
                  })
                )
                .then(function(response) {
                  if (response.data.code === 0) {
                    change_token(response.data);
                    axios.defaults.headers.common["Authorization"] =
                      response.data.access_token;
                    if (_this.isshool) {
                      axios.get("/s/api/school/get/user/school").then(res => {
                        if (res.data.code == 0) {
                          if (res.data.data.freeStatus == 1) {
                            _this.$message({
                              message: "账号处于试用期，登录成功",
                              type: "success",
                              duration: 3000,
                              onClose() {
                                location.replace(Net_Work.publicPhoneAddress);
                              }
                            });
                          } else {
                            if (res.data.data.auditStatus == 1) {
                              location.replace(Net_Work.publicPhoneAddress);
                            } else {
                              _this.$message({
                                message: "账号审核中，跳转审核信息完善页面",
                                type: "success",
                                duration: 3000,
                                onClose() {
                                  this.$router.push("/upgrade-school-account");
                                }
                              });
                            }
                          }
                        }
                      });
                    } else {
                      _this.$message({
                        message: response.data.msg,
                        type: "success",
                        duration: 3000,
                        onClose() {
                          location.replace(Net_Work.publicPhoneAddress);
                        }
                      });
                    }
                  } else {
                    _this.$message({
                      showClose: true,
                      message: response.data.msg,
                      type: "error"
                    });
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
            } else {
              _this.$message({
                showClose: true,
                message: "网络错误",
                type: "error"
              });
            }
          })
          .catch(function(error) {});
      }
    }, 2000),
    showChild(data) {
      this.school_title = data;
      window.sessionStorage.setItem("schoolname", this.school_title);
      this.isshool = true;
    }
  },
  mounted() {
    if (window.sessionStorage.getItem("schoolname")) {
      this.school_title = window.sessionStorage.getItem("schoolname");
      this.isshool = true;
    }
  },
  created() {
    this.JSEncrypt = new this.JSEncrypt();
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="less">
#login_wrap_denglu {
  width: 100%;
  height: 155px;
  overflow: hidden;
  background-color: #eee;
  text-align: center;
  .login_wrap_denglu_top {
    font-family: " MicrosoftYaHei";
    font-size: 30px;
    color: #222743;
    margin-top: 45px;
    line-height: 52px;
    letter-spacing: 1px;
  }
  .yanzhengma_enter {
    color: #066fff;
    font-family: " MicrosoftYaHei";
    margin-top: 10px;
    display: inline-block;
  }
}
#login_wrap_form {
  width: 100%;
  padding-bottom: 80px;
  .colordisplay {
    visibility: hidden;
  }
  .colordisplays {
    visibility: hidden;
  }
  .number_erro {
    display: flex;
    margin-top: 3px;
    justify-content: flex-end;
    .number_erro_content {
      margin-right: 50px;
      width: 170px;
      font-size: 12px;
      color: #f56c6c;
      font-family: "MicrosoftYaHei";
      /**/
    }
  }
  .password_erro {
    margin-left: 50px;
    font-size: 12px;
    color: #f56c6c;
    margin-top: 3px;
    font-family: "MicrosoftYaHei";
  }
  .login_wrap_form_wrap {
    width: 360px;
    height: auto;
    margin: 0 auto;
    margin-top: 36px;
    .login_wrap_form_wrap_tip {
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #999999;
      margin-left: 50px;
    }
    .login_wrap_form_number {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
    .login_wrap_form_number_left {
      margin-left: 50px;
    }
  }
  .login_wrap_form_number_left_se {
    width: 80px;
    height: 30px;
  }
  .login_wrap_form_number_right {
    margin-right: 50px;
    width: 170px;
  }
  .login_wrap_for_enter {
    margin-left: 50px;
    margin-top: 12px;
    .login_wrap_for_enter_con {
      width: 260px;
      line-height: 30px;
      text-align: center;
      background-color: #3366ff;
      font-family: "MicrosoftYaHei";
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .login_wrap_form_forget_zhuce {
    display: flex;
    margin-top: 8px;
    justify-content: space-between;
    .login_wrap_form_forget {
      font-family: " MicrosoftYaHei";
      font-size: 12px;
      color: #222743;
      margin-left: 50px;
    }
    .login_wrap_form_zhuce {
      font-family: " MicrosoftYaHei";
      font-size: 12px;
      color: #066fff;
      margin-right: 50px;
    }
  }
}
</style>
<style lang="less">
/*设置element ui 自定义ui样式*/
.login_wrap_form_number_left_se {
  .el-input__inner {
    padding: 0;
    margin: 0;
    padding-left: 11px;
    border-radius: 3px;
    height: 30px;
  }
  .el-input__suffix {
    right: -2px;
  }
  .el-input__icon {
    line-height: 30px;
  }
}
.login_wrap_form_number_right_int .el-input__inner {
  height: 30px;
  border-radius: 3px;
}
.login_wrap_form_passworld {
  width: 260px;
  margin-left: 50px;
  margin-top: 30px;
  .el-input__inner {
    height: 30px;
  }
}
.colorerro {
  .el-input__inner {
    border-color: #f56c6c;
  }
}
.colorpasserro {
  .el-input__inner {
    border-color: #f56c6c;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue